<template>
  <div
    class="flex flex-column w-full h-full justify-content-between align-items-stretch tw-font-geist"
  >
    <div class="flex flex-column align-items-stretch tw-gap-2">
      <div class="px-2 flex align-items-center pt-2 pb-4 gap-2 tw-w-full">
        <JamxLogo
          logo-class="tw-fill-violet-500 dark:tw-fill-green-400"
          style="width: 1.2rem; height: 1.7rem"
        />
        <div class="tw-font-medium tw-text-slate-700 dark:tw-text-slate-50">
          JamX
        </div>
      </div>
      <router-link v-if="!adminUserData?.isLimitedAdmin" :to="dashboardLink()">
        <CustomButton
          label="Dashboard"
          icon="pi pi-home"
          icon-class="tw-text-sm"
          class="w-full tw-gap-3"
          :text="!isLinkActive('Dashboard')"
          :severity="isLinkActive('Dashboard') ? 'primary' : 'neutral'"
          align="left"
        />
      </router-link>

      <template v-if="getRoleByState() == 'partner'">
        <router-link to="/groups"
          ><CustomButton
            label="Groups"
            icon="pi pi-th-large"
            icon-class="tw-text-sm"
            :text="!isLinkActive('GroupsList')"
            :severity="isLinkActive('GroupsList') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/sellers"
          ><CustomButton
            label="Sellers"
            icon="pi pi-users"
            icon-class="tw-text-sm"
            :text="!isLinkActive('SellersList')"
            :severity="isLinkActive('SellersList') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/playlists"
          ><CustomButton
            label="Playlists"
            icon="pi pi-bolt"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PlaylistsList')"
            :severity="isLinkActive('PlaylistsList') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link v-if="partner?.can_manage_demand_tags" to="/tags"
          ><CustomButton
            label="Tags List"
            icon="pi pi-tag"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PartnerTagsList')"
            :severity="isLinkActive('PartnerTagsList') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/developers"
          ><CustomButton
            label="Developer API"
            icon="pi pi-key"
            icon-class="tw-text-sm"
            :text="!isLinkActive('DeveloperAPI')"
            :severity="isLinkActive('DeveloperAPI') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/publisher-onboarding-links"
          ><CustomButton
            label="Onboard Links"
            icon="pi pi-link"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PublisherOnboardingLinks')"
            :severity="
              isLinkActive('PublisherOnboardingLinks') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
      </template>
      <template v-if="getRoleByState() == 'group-admin'">
        <router-link to="/group-admin/sellers"
          ><CustomButton
            label="Domains"
            icon="pi pi-server"
            icon-class="tw-text-sm"
            :text="!isLinkActive('GroupAdminSellersList')"
            :severity="
              isLinkActive('GroupAdminSellersList') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/group-admin/developers"
          ><CustomButton
            label="Developer API"
            icon="pi pi-key"
            icon-class="tw-text-sm"
            :text="!isLinkActive('DeveloperAPI')"
            :severity="isLinkActive('DeveloperAPI') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
      </template>
      <template v-if="getRoleByState() == 'admin'">
        <router-link to="/admin/management-dashboard"
          ><CustomButton
            label="Management Dashboard"
            icon="pi pi-chart-line"
            icon-class="tw-text-sm"
            :text="!isLinkActive('AdminManagement')"
            :severity="isLinkActive('AdminManagement') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/admin/custom-reports"
          ><CustomButton
            label="Reports"
            icon="pi pi-file-export"
            icon-class="tw-text-sm"
            :text="!isLinkActive('Reports')"
            :severity="isLinkActive('Reports') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link v-if="!adminUserData?.isLimitedAdmin" to="/admin/partners"
          ><CustomButton
            label="Partners"
            icon="pi pi-sitemap"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PartnersList')"
            :severity="isLinkActive('PartnersList') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/admin/groups"
          ><CustomButton
            :badge="
              notifications.groupsNotifyCount > 0
                ? notifications.groupsNotifyCount > 5
                  ? '5+'
                  : notifications.groupsNotifyCount
                : null
            "
            badge-severity="danger"
            label="Groups"
            icon="pi pi-th-large"
            icon-class="tw-text-sm"
            :text="!isLinkActive('AdminGroupsList')"
            :severity="isLinkActive('AdminGroupsList') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/admin/sellers"
          ><CustomButton
            :badge="
              notifications.sellersNotifyCount > 5
                ? '5+'
                : notifications.sellersNotifyCount
            "
            badge-severity="danger"
            label="Sellers Approvals"
            icon="pi pi-verified"
            icon-class="tw-text-sm"
            :text="!isLinkActive('AdminSellers')"
            :severity="isLinkActive('AdminSellers') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link v-if="!adminUserData?.isLimitedAdmin" to="/admin/tags"
          ><CustomButton
            label="Tags List"
            icon="pi pi-tag"
            icon-class="tw-text-sm"
            :text="!isLinkActive('TagsList')"
            :severity="isLinkActive('TagsList') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link
          v-if="!adminUserData?.isLimitedAdmin"
          to="/admin/tag-groups"
          ><CustomButton
            label="Tag Groups List"
            icon="pi pi-tags"
            icon-class="tw-text-sm"
            :text="!isLinkActive('TagGroupsList')"
            :severity="isLinkActive('TagGroupsList') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link
          v-if="!adminUserData?.isLimitedAdmin"
          to="/admin/config-manager"
          ><CustomButton
            label="Config Manager"
            icon="pi pi-sliders-h"
            icon-class="tw-text-sm"
            :text="!isLinkActive('ConfigManager')"
            :severity="isLinkActive('ConfigManager') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link
          v-if="!adminUserData?.isLimitedAdmin"
          to="/admin/ads-txt-manager"
          ><CustomButton
            label="Ads.txt Manager"
            icon="pi pi-file-edit"
            icon-class="tw-text-sm"
            :text="!isLinkActive('AdsTxt')"
            :severity="isLinkActive('AdsTxt') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link
          v-if="!adminUserData?.isLimitedAdmin"
          to="/admin/content-packs"
          ><CustomButton
            label="Content Packs"
            icon="pi pi-gift"
            icon-class="tw-text-sm"
            :text="!isLinkActive('ContentPacks')"
            :severity="isLinkActive('ContentPacks') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link
          v-if="!adminUserData?.isLimitedAdmin"
          to="/admin/argus-snapshot"
          ><CustomButton
            label="Argus"
            icon="pi pi-eye"
            icon-class="tw-text-sm"
            :text="!isLinkActive('ArgusSnapshot')"
            :severity="isLinkActive('ArgusSnapshot') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/admin/publisher-onboarding-links"
          ><CustomButton
            label="Onboard Links"
            icon="pi pi-link"
            icon-class="tw-text-sm"
            :text="!isLinkActive('AdminPublisherOnboardingLinks')"
            :severity="
              isLinkActive('AdminPublisherOnboardingLinks')
                ? 'primary'
                : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/admin/scheduled-reports"
          ><CustomButton
            label="Scheduled Reports"
            icon="pi pi-calendar"
            icon-class="tw-text-sm"
            :text="!isLinkActive('AdminReportSchedules')"
            :severity="
              isLinkActive('AdminReportSchedules') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link
          v-if="!adminUserData?.isLimitedAdmin"
          to="/admin/group-account-managers"
          ><CustomButton
            label="Group Owners"
            icon="pi pi-users"
            icon-class="tw-text-sm"
            :text="!isLinkActive('GroupAccountManagers')"
            :severity="
              isLinkActive('GroupAccountManagers') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link
          v-if="!adminUserData?.isLimitedAdmin"
          to="/admin/accounting"
          ><CustomButton
            :badge="
              notifications.accountingPendingCount > 0
                ? notifications.accountingPendingCount > 5
                  ? '5+'
                  : notifications.accountingPendingCount
                : null
            "
            badge-severity="danger"
            label="Accounting"
            icon="pi pi-money-bill"
            icon-class="tw-text-sm"
            :text="!isLinkActive('AdminAccounting')"
            :severity="isLinkActive('AdminAccounting') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
      </template>
      <template v-if="getRoleByState() == 'podcaster'">
        <router-link to="/podcaster/shows"
          ><CustomButton
            label="Shows"
            icon="pi pi-wifi"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PodcastShowsList')"
            :severity="isLinkActive('PodcastShowsList') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/podcaster/episodes"
          ><CustomButton
            label="Episodes"
            icon="pi pi-play"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PodcasterEpisodesList')"
            :severity="
              isLinkActive('PodcasterEpisodesList') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/podcaster/referrals"
          ><CustomButton
            label="Referrals"
            icon="pi pi-users"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PodcasterReferralsList')"
            :severity="
              isLinkActive('PodcasterReferralsList') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
      </template>
      <template v-if="getRoleByState() == 'podcastAdmin'">
        <router-link to="/podcast-admin/custom-reports"
          ><CustomButton
            label="Reports"
            icon="pi pi-table"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PodcastAdminCustomReports')"
            :severity="
              isLinkActive('PodcastAdminCustomReports') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/podcast-admin/stats-reports"
          ><CustomButton
            label="Stats"
            icon="pi pi-chart-bar"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PodcastAdminStatsReports')"
            :severity="
              isLinkActive('PodcastAdminStatsReports') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/podcast-admin/accounting"
          ><CustomButton
            :badge="
              notifications.accountingPendingCount > 0
                ? notifications.accountingPendingCount > 5
                  ? '5+'
                  : notifications.accountingPendingCount
                : null
            "
            badge-severity="danger"
            label="Accounting"
            icon="pi pi-money-bill"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PodcastAdminAccounting')"
            :severity="
              isLinkActive('PodcastAdminAccounting') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/podcast-admin/shows"
          ><CustomButton
            label="Shows"
            icon="pi pi-wifi"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PodcastAdminShowsList')"
            :severity="
              isLinkActive('PodcastAdminShowsList') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/podcast-admin/episodes"
          ><CustomButton
            label="Episodes"
            icon="pi pi-play"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PodcastAdminEpisodesList')"
            :severity="
              isLinkActive('PodcastAdminEpisodesList') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/podcast-admin/podcasters"
          ><CustomButton
            label="Podcasters"
            icon="pi pi-th-large"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PodcastersList')"
            :severity="isLinkActive('PodcastersList') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/podcast-admin/gifts"
          ><CustomButton
            label="Gifts"
            icon="pi pi-gift"
            icon-class="tw-text-sm"
            :text="!isLinkActive('Gifts')"
            :severity="isLinkActive('Gifts') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/podcast-admin/networks"
          ><CustomButton
            label="Networks"
            icon="pi pi-sitemap"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PodcastNetworksList')"
            :severity="
              isLinkActive('PodcastNetworksList') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/podcast-admin/hosting-seats"
          ><CustomButton
            :badge="
              notifications.hostingValidationCount > 0
                ? notifications.hostingValidationCount > 99
                  ? '100+'
                  : notifications.hostingValidationCount
                : null
            "
            badge-severity="danger"
            label="Hosting Seats"
            icon="pi pi-server"
            icon-class="tw-text-sm"
            :text="!isLinkActive('HostingPlatformSeatsList')"
            :severity="
              isLinkActive('HostingPlatformSeatsList') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/podcast-admin/campaigns"
          ><CustomButton
            label="Campaigns"
            icon="pi pi-volume-up"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PodcastAdminCampaignsList')"
            :severity="
              isLinkActive('PodcastAdminCampaignsList') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
        <router-link to="/podcast-admin/alert-room"
          ><CustomButton
            label="Activity Log"
            icon="pi pi-history"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PodcastAdminAlertRoom')"
            :severity="
              isLinkActive('PodcastAdminAlertRoom') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>

        <router-link to="/podcast-admin/podcast-generation">
          <CustomButton
            label="Auxigen"
            icon="pi pi-microphone"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PodcastGeneration')"
            :severity="
              isLinkActive('PodcastGeneration') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
      </template>

      <template v-if="getRoleByState() == 'auxigen'">
        <router-link to="/auxigen/podcast-generation">
          <CustomButton
            label="Auxigen"
            icon="pi pi-microphone"
            icon-class="tw-text-sm"
            :text="!isLinkActive('AuxigenPodcastGenerationList')"
            :severity="
              isLinkActive('AuxigenPodcastGenerationList')
                ? 'primary'
                : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
        /></router-link>
      </template>

      <template v-if="getRoleByState() == 'network-admin'">
        <!-- <router-link to="/network-admin/shows">
          <CustomButton
            label="Shows"
            icon="pi pi-wifi"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PodcastShowsList')"
            :severity="isLinkActive('PodcastShowsList') ? 'primary' : 'neutral'"
            class="w-full tw-gap-3"
            align="left"
          />
        </router-link> -->

        <!-- <router-link to="/network-admin/episodes">
          <CustomButton
            label="Episodes"
            icon="pi pi-play"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PodcasterEpisodesList')"
            :severity="
              isLinkActive('PodcasterEpisodesList') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
          />
        </router-link> -->

        <!-- <router-link to="/network-admin/network">
          <CustomButton
            label="Network"
            icon="pi pi-users"
            icon-class="tw-text-sm"
            :text="!isLinkActive('PodcasterReferralsList')"
            :severity="
              isLinkActive('PodcasterReferralsList') ? 'primary' : 'neutral'
            "
            class="w-full tw-gap-3"
            align="left"
          />
        </router-link> -->
      </template>
    </div>
    <div class="w-full">
      <div class="tw-w-full tw-flex tw-justify-between tw-items-center tw-mb-2">
        <CustomButton
          icon="pi pi-cog"
          icon-class="tw-text-sm"
          label="Settings"
          severity="neutral"
          text
          class="tw-gap-3"
          align="left"
          @click="
            toast.add({
              severity: 'success',
              summary: 'Settings',
              detail: 'Will be available soon!',
              life: 5000,
            })
          "
        />
        <CustomButton
          :icon="`pi ${
            store.getters.currentTheme == 'dark' ? 'pi-sun' : 'pi-moon'
          }`"
          icon-class="tw-text-sm"
          severity="neutral"
          text
          round
          @click="toggleTheme"
        />
      </div>
      <CustomButton
        icon-class="tw-text-sm"
        icon="pi pi-user"
        text
        severity="neutral"
        class="tw-w-full tw-gap-3"
        align="left"
        @click="(e) => emit('toggleMenu', e)"
        ><div class="tw-max-w-full tw-line-clamp-1 tw-truncate">
          {{ userEmail }}
        </div></CustomButton
      >
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { computed, onBeforeMount, ref, defineEmits } from "vue";

import axios from "axios";
import { API_BASE_URL } from "@/consts";
import JamxLogo from "./icons/JamxLogo.vue";
import CustomButton from "./components_new/Button.vue";
import { useToast } from "primevue/usetoast";
import { usePrimeVue } from "primevue/config";

const router = useRouter();
const store = useStore();
const toast = useToast();
const PrimeVue = usePrimeVue();
const partner = JSON.parse(localStorage.getItem("partner"));

const emit = defineEmits(["toggleMenu"]);

// const adminUserData = JSON.parse(localStorage.getItem("admin"));
const adminUserData = store.state.admin;

const notifications = ref({
  sellersNotifyCount: 0,
  groupsNotifyCount: 0,
  accountingPendingCount: 0,
  hostingValidationCount: 0,
});

const toggleTheme = () => {
  store.commit("switchTheme");
  // PrimeVue.changeTheme("dark", "light", "theme-link", () => {});
  PrimeVue.changeTheme(
    `${store.getters.currentTheme == "dark" ? "light" : "dark"}`,
    `${store.getters.currentTheme}`,
    "theme-link",
    () => {}
  );
};

const getRoleByState = () => {
  if (store.getters.isSellerLoggedIn) {
    return "seller";
  } else if (store.getters.isGroupAdminLoggedIn) {
    return "group-admin";
  } else if (store.getters.isAdminLoggedIn) {
    return "admin";
  } else if (store.getters.isPodcasterLoggedIn) {
    return "podcaster";
  } else if (store.getters.isPodcastAdminLoggedIn) {
    return "podcastAdmin";
  } else if (store.getters.isNetworkAdminLoggedIn) {
    return "network-admin";
  } else if (store.getters.isAuxigenLoggedIn) {
    return "auxigen";
  } else if (store.getters.isLoggedIn) {
    return "partner";
  }
};

const userEmail = computed(() => {
  switch (getRoleByState()) {
    case "seller":
      return JSON.parse(localStorage.getItem("seller"))?.email;
    case "group-admin":
      return JSON.parse(localStorage.getItem("groupAdmin"))?.email;
    case "partner":
      return JSON.parse(localStorage.getItem("partner"))?.email;
    case "admin":
      return JSON.parse(localStorage.getItem("admin"))?.email;
    case "podcaster":
      return JSON.parse(localStorage.getItem("podcaster"))?.email;
    case "podcastAdmin":
      return JSON.parse(localStorage.getItem("podcastAdmin"))?.email;
    case "network-admin":
      return JSON.parse(localStorage.getItem("networkAdmin"))?.email;
    case "auxigen":
      return JSON.parse(localStorage.getItem("auxigen"))?.email;
    default:
      return "unknown";
  }
});

const dashboardLink = () => {
  switch (getRoleByState()) {
    case "seller":
      return "/seller/dashboard";
    case "group-admin":
      return "/group-admin/dashboard";
    case "partner":
      return "/dashboard";
    case "admin":
      return "/admin/dashboard-new";
    case "podcaster":
      return "/podcaster/dashboard";
    case "podcastAdmin":
      return "/podcast-admin/dashboard";
    case "network-admin":
      return "/network-admin/dashboard";
    case "auxigen":
      return "/auxigen/podcast-generation";
    default:
      return "/dashboard";
  }
};

const isLinkActive = (rtrName) =>
  router.currentRoute.value.name
    ? router.currentRoute.value.name.includes(rtrName)
    : false;

const logout = () => {
  localStorage.clear();
  window.location.replace("/");
};

const getNotificationCounts = async () => {
  try {
    const role = getRoleByState();
    const endpointMap = {
      admin: `${API_BASE_URL}/admin/notification-counts`,
      podcastAdmin: `${API_BASE_URL}/podcast-admin/notification-counts`,
    };
    const tokenKey =
      role === "admin"
        ? "adminToken"
        : role === "podcastAdmin"
        ? "podcastAdminToken"
        : null;

    if (!tokenKey || !endpointMap[role]) return;

    const token = localStorage.getItem(tokenKey);
    if (!token?.length) return;

    const response = await axios.get(endpointMap[role], {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.data.success) {
      notifications.value = {
        ...notifications.value,
        ...(response.data.data || {}),
      };
    }
  } catch (error) {
    console.error("Error fetching notification counts:", error);
  }
};

onBeforeMount(() => {
  getNotificationCounts();
});
</script>
